import React from 'react';
import ReactDOM from 'react-dom/client';  // تغییر این بخش
import App from './App';
import './index.css';  // اگر فایل CSS دارید، می‌توانید این را اضافه کنید

// ایجاد روت با استفاده از createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));  // تغییر این بخش
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
